import styled from 'styled-components';

const css = styled.div;

export default css``;
